export const localeToRegionIdMap = {
  'vi': 'VN',
  'hk': 'HK',
  'tw': 'TWN'
}
export const localeTenementIdMap = {
  'vi': '10870016',
  'hk': '10870011',
  'tw': '10870011'
}